(function () {
  function formatInches(mmValue) {
    const inches = Number(mmValue) / 25.4;
    return `${parseFloat(inches.toFixed(2))}in`;
  }

  function formatMillimeters(mmValue) {
    return `${mmValue}mm`;
  }

  function initProductDetails() {
    document.querySelectorAll('[data-product-details]').forEach((section) => {
      if (section.__productDetailsReady) return;
      section.__productDetailsReady = true;

      const toggle = section.querySelector('[data-product-details-toggle]');
      const values = Array.from(section.querySelectorAll('[data-product-details-mm]'));
      const skuNode = section.querySelector('[data-product-details-sku]');
      const sectionId = section.dataset.productDetailsSection;
      let useInches = false;

      if (!toggle || values.length === 0) {
        if (toggle) toggle.hidden = true;
      } else {
        toggle.addEventListener('click', () => {
          useInches = !useInches;

          values.forEach((node) => {
            const mmValue = node.dataset.productDetailsMm;
            node.textContent = useInches ? formatInches(mmValue) : formatMillimeters(mmValue);
          });

          toggle.textContent = useInches ? 'show in mm' : 'show in inches';
        });
      }

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && skuNode) {
        section.__productDetailsVariantUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (!event?.data?.variant) return;
          if (sectionId && event.data.sectionId !== sectionId) return;

          skuNode.textContent = event.data.variant.sku || '-';
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductDetails);
  } else {
    initProductDetails();
  }
})();
